import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ValidatorNameService } from '../services/validator-name.service';
import { ValidatorPropertyHandler } from './validator-property-handler';
import { AbstractValidatorEditor } from '../types';

@Injectable({
  providedIn: 'root'
})
export class UnionCheckNamePropertyService implements ValidatorPropertyHandler<any> {
  validatorName: string = 'unionCheck';

  constructor(private nameService: ValidatorNameService) {}

  handleData(data: any, validator: AbstractValidatorEditor<any>): Observable<any> {
    return this.nameService.handleUnionCheckName(data, validator);
  }
}
